import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import {
  Route,
  useLocation,
  BrowserRouter as Router,
  Switch,
} from "react-router-dom";
import { createBrowserHistory } from "history";

import { Home } from "./features/Home/view";
import { FAQ } from "./features/FAQ/view";
import { Login } from "./features/Login/view";
import { OTP } from "./features/Otp/view";
import { Cart } from "./features/Cart/view";

import { Requests } from "./features/Requests/view";
import { RequestDetails } from "./features/RequestDetails/view";
import { Invoices } from "./features/Invoices/view";

import { SchoolGuide } from "./features/School/Guide/view";
import { SchoolDisclaimer } from "./features/School/Disclaimer/view";
import { SchoolForm } from "./features/School/Form/view";
import { SchoolSummary } from "./features/School/Summary/view";

import { MarriageGuide } from "./features/Marriage/Guide/view";
import { MarriageDisclaimer } from "./features/Marriage/Disclaimer/view";
import { MarriageForm } from "./features/Marriage/Form/view";
import { MarriageSummary } from "./features/Marriage/Summary/view";

import { ArchivalGuide } from "./features/Archival/Guide/view";
import { ArchivalDisclaimer } from "./features/Archival/Disclaimer/view";
import { ArchivalForm } from "./features/Archival/Form/view";
import { ArchivalSummary } from "./features/Archival/Summary/view";

import { PictureSgGuide } from "./features/PictureSg/Guide/view";
import { PictureSgDisclaimer } from "./features/PictureSg/Disclaimer/view";

import { PaymentCancelled } from "./features/Payment/cancelled";
import { PaymentFailed } from "./features/Payment/failed";
import { OrderSuccess } from "./features/Payment/success";

import { LogoutRedirect } from "./features/Logout/view";

import { Header } from "./Components/Header/view";
import { Footer } from "./Components/Footer";
import { ScrollToTop } from "./Components/ScrollTop";

import NotFound from "./NotFound";


function App() {
  const history = createBrowserHistory();
  const removeScrollingINput = (e) => {
    if (
      document.activeElement.type === "number" &&
      document.activeElement.classList.contains("noscroll")
    ) {
      document.activeElement.blur();
    }

    // });
  };
  useEffect(() => {

    // testSecretManager();
    document.addEventListener("wheel", removeScrollingINput);
    return () => {
      window.removeEventListener("wheel", removeScrollingINput);
    };
  }, []);
  return (
    <Router basename={process.env.PUBLIC_URL} history={history}>
      {/* <Router basename={'/erequest-v2'} history={history}>
    {/* <ScrollToTop /> */}
      <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
        <Header />
        <div className="flex-grow-1">
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/school" exact />
            <Route path="/school/guide" component={SchoolGuide} />
            <Route path="/school/disclaimer" component={SchoolDisclaimer} />
            <Route path="/school/form" component={SchoolForm} />
            <Route path="/school/summary" component={SchoolSummary} />
            <Route path="/marriage" exact />
            <Route path="/marriage/guide" component={MarriageGuide} />
            <Route path="/marriage/disclaimer" component={MarriageDisclaimer} />
            <Route path="/marriage/form" component={MarriageForm} />
            <Route path="/marriage/summary" component={MarriageSummary} />
            <Route path="/archival" exact />
            <Route path="/archival/guide" component={ArchivalGuide} />
            <Route path="/archival/disclaimer" component={ArchivalDisclaimer} />
            <Route path="/archival/form" component={ArchivalForm} />
            <Route path="/archival/summary" component={ArchivalSummary} />
            <Route path="/picturesg" exact />
            <Route path="/picturesg/guide" component={PictureSgGuide} />
            <Route
              path="/picturesg/disclaimer"
              component={PictureSgDisclaimer}
            />
            <Route path="/faq" component={FAQ} />
            <Route path="/login" component={Login} />
            <Route path="/otp" component={OTP} />
            <Route path="/mycart" component={Cart} />
            <Route path="/#/mycart" component={Cart} />
            <Route path="/requests" component={Requests} />
            <Route path="/my-requests/:orderId" component={RequestDetails} />
            <Route path="/my-invoices/:orderId" component={Invoices} />
            <Route path="/payment/cancelled" component={PaymentCancelled} />
            <Route path="/payment/failed" component={PaymentFailed} />
            <Route path="/order/success" component={OrderSuccess} />
            <Route path="/logout" component={LogoutRedirect} />
            <Route path="*" component={NotFound} />
          </Switch>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
